import { useState, useEffect } from "react";

export function useMapScale(selectedMap, maps, mapRefs) {
  const [markerScale, setMarkerScale] = useState(1);

  // Helper for određivanje scale-a
  const getMarkerScaleForSize = (base) => {
    let scale = 0;
    if (base <= 500) scale = 0.65;
    else if (base <= 700) scale = 0.81;
    else if (base <= 900) scale = 0.84;
    else if (base <= 1080) scale = 0.85;
    else if (base <= 1280) scale = 0.98;
    else if (base <= 1440) scale = 1.05;
    else if (base <= 1920) scale = 1.2;
    else if (base <= 2560) scale = 1.3;
    else scale = 1.4;
    return scale;
  };

  useEffect(() => {
    let timeoutId;
    function updateScale() {
      if (!selectedMap || !maps.length) return;
      const ref = mapRefs.current[selectedMap];
      if (!ref) return;
      let base = ref.offsetWidth || window.innerWidth;
      const scale = getMarkerScaleForSize(base);
      setMarkerScale(scale);
    }
    function handleResize() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(updateScale, 150);
    }
    updateScale();
    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, [maps, selectedMap, mapRefs]);

  useEffect(() => {
    if (!selectedMap) return;
    if (!maps.length) return;
    const ref = mapRefs.current[selectedMap];
    if (!ref) return;
    const timeout = setTimeout(() => {
      let base = ref.offsetWidth || window.innerWidth;
      const scale = getMarkerScaleForSize(base);
      setMarkerScale(scale);
    }, 200);
    return () => clearTimeout(timeout);
  }, [maps, selectedMap, mapRefs]);

  return markerScale;
}
